import Link from "next/link";

import { routes } from "src/shared/routes";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question:
      "How do I claim my tickets? When does the opt in open before each game?",
    answer:
      "You will receive a text when the check-in window opens at 9:00 AM the day before the homestand begins.",
  },
  {
    question:
      "Do I get a ticket to each game on the schedule? Are there penalties if I do not check-in?",
    answer:
      "Tickets are guaranteed for each game on the schedule. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "Your tickets will be sent over 3 hours prior to game start and you can find the tickets within your Reno Aces MyTickets account.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "3 hours prior to game start you will receive a text confirming that tickets have been delivered to your Reno Aces MyTickets account.",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations will vary by game.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "All Access Pass tickets, as well as seat upgrades and guest passes, are not eligible for resale. Abusing these guidelines can result in your All Access Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer: (
      <>
        Once tickets have been sent to your account, they cannot be changed.
        Please contact{" "}
        <Link href="mailto:info@renoaces.com">info@renoaces.com</Link> for any
        assistance you may require.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets & upgrades will be available for select games. If available, guest tickets are available for purchase when you opt into games.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my All Access Pass?",
    answer: (
      <>
        Please contact{" "}
        <Link href="mailto:info@renoaces.com">info@renoaces.com</Link> for any
        requests for refunds or cancellations
      </>
    ),
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    In connection with your purchase, you will receive ticket-related commercial
    emails from renoaces.com. You may unsubscribe at any time. By checking this
    box you agree to receive additional commercial emails from renoaces.com and
    MLB.com. Upon completing your purchase by selecting Purchase Tickets you
    acknowledge and agree that your credit card will be charged. By clicking
    “Purchase Tickets”, you agree to the{" "}
    <Link
      href={
        "https://www.mlb.com/app/ballpark/official-information/privacy-policy"
      }
      target="_blank"
    >
      MLB Privacy Policy
    </Link>
    ,{" "}
    <Link
      href={
        "https://www.mlb.com/app/ballpark/official-information/terms-of-use"
      }
      target="_blank"
    >
      Terms of Use
    </Link>{" "}
    and to receive your ticket(s) via an SMS text message to the mobile #
    associated with your Reno Aces account. Messaging and data rates may apply.
    Tickets will be made available in the MLB Ballpark mobile application only.
    MLB.com and supported mobile device required.
  </>
);

export const PASS_PURCHASE_SUCCESS_MESSAGE: TTeamConfig["LANGUAGES"]["PASS_PURCHASE_SUCCESS_MESSAGE"] =
  {
    TITLE: () => (
      <>
        You&apos;e all set to experience the action! Don&apos;t forget to
        confirm attendance here on game day!
      </>
    ),
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Friends don&apos;t leave friends behind.{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                Invite your friends
              </span>
            </u>
          </b>{" "}
          and enjoy games together.
        </>
      );
    },
  };
